import { getPerformanceNavigationTiming } from '../internal/util';
const generateConfig = (ttapConfig) => {
    try {
        const config = {};
        if (!ttapConfig.disableReleaseVersionAutoConfig) {
            try {
                let release = ttapConfig.release;
                if (!release) {
                    release = process.env.BUILD_VERSION;
                }
                if (release) {
                    config.release = release;
                }
            }
            catch {
                //do nothing
            }
        }
        if (!ttapConfig.disableEnvAutoConfig) {
            try {
                let env = ttapConfig.env;
                if (!env) {
                    env = process.env.CUSTOM_BUILD_ENV;
                }
                if (env) {
                    config.env = env;
                }
            }
            catch {
                //do nothing
            }
        }
        if (Object.keys(config).length > 0) {
            return config;
        }
    }
    catch {
        //do nothing
    }
};
class Client {
    constructor(clientFn) {
        this._state = {
            bid: undefined,
            pid: undefined,
            isSpaRouteCheck: false,
            ignoreApiUrl: [/mcs.*\.tiktok[vw]?\.(com|us|eu)/, /mon\.tiktokv\.(com|us|eu)/],
            includeApiUrl: [],
            vmok: undefined,
        };
        this._tempSlardarCalls = [];
        this._tempSlardarOns = [];
        this._isReady = false;
        this._hasAdditionalContext = false;
        this.callClient = (m, e) => {
            if (this._isReady) {
                this._callSlardarWeb(m, e);
            }
            else {
                this._tempSlardarCalls.push({ m, e });
            }
        };
        this.on = (e, handler) => {
            if (this._isReady) {
                this._onSlardarWeb(e, handler);
            }
            else {
                this._tempSlardarOns.push({ e, handler });
            }
        };
        this._flushTempSlardarCalls = () => {
            this._tempSlardarCalls.forEach(({ m, e }) => {
                this.callClient(m, e);
            });
            this._tempSlardarCalls = [];
        };
        this._flushTempSlardarOns = () => {
            this._tempSlardarOns.forEach(({ e, handler }) => {
                this.on(e, handler);
            });
            this._tempSlardarOns = [];
        };
        this._updateConfigSlardarWeb = (config) => {
            var _a;
            (_a = this._slardarClientFn()) === null || _a === void 0 ? void 0 : _a('config', config);
        };
        this._callSlardarWeb = (m, e) => {
            const slardarClient = this._slardarClientFn();
            if (!slardarClient) {
                return;
            }
            if (m === 'report') {
                slardarClient(m, e);
            }
            else if (m === 'sendEvent') {
                slardarClient(m, e);
            }
            else if (m === 'sendCustomPerfMetric') {
                slardarClient(m, e);
            }
        };
        this._onSlardarWeb = (e, handler) => {
            const slardarClient = this._slardarClientFn();
            if (!slardarClient) {
                return;
            }
            slardarClient('on', e, handler);
        };
        this._slardarClientFn = clientFn;
    }
    getState() {
        return this._state;
    }
    setState(state) {
        var _a, _b;
        try {
            const { bid, pid } = (_b = (_a = this._slardarClientFn()) === null || _a === void 0 ? void 0 : _a('config')) !== null && _b !== void 0 ? _b : {};
            this._state = { ...this._state, ...state, bid, pid };
        }
        catch {
            // do nothing
        }
    }
    deregisterClient() {
        this._hasAdditionalContext = false;
        this._isReady = false;
    }
    start() {
        var _a;
        (_a = this._slardarClientFn()) === null || _a === void 0 ? void 0 : _a('start');
    }
    registerClient(config) {
        const { includeApiUrl, ignoreApiUrl, vmok, isSpa } = config;
        const state = {};
        const client = this._slardarClientFn();
        if (!client) {
            return Promise.resolve(false);
        }
        if (includeApiUrl && Array.isArray(includeApiUrl)) {
            state.includeApiUrl = [...includeApiUrl];
        }
        if (ignoreApiUrl && Array.isArray(ignoreApiUrl)) {
            state.ignoreApiUrl = Array.isArray(state.ignoreApiUrl)
                ? [...state.ignoreApiUrl, ...ignoreApiUrl]
                : [...ignoreApiUrl];
        }
        if (vmok === null || vmok === void 0 ? void 0 : vmok.name) {
            state.vmok = vmok;
        }
        if (this._hasAdditionalContext) {
            //refreshPreStartContext https://code.byted.org/appmonitor/slardar_sdk/blob/develop/packages/integrations/src/refreshPreStartContext.ts
            client('on', 'start', () => {
                var _a;
                try {
                    const client = this._slardarClientFn();
                    const preStartQueue = (_a = client === null || client === void 0 ? void 0 : client.getPreStartQueue()) !== null && _a !== void 0 ? _a : [];
                    preStartQueue.forEach((ev, index) => {
                        var _a, _b;
                        preStartQueue[index] = {
                            ...ev,
                            overrides: {
                                ...((_a = ev.overrides) !== null && _a !== void 0 ? _a : {}),
                                // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
                                context: ((_b = client === null || client === void 0 ? void 0 : client.context) === null || _b === void 0 ? void 0 : _b.toString()) || {},
                            },
                        };
                    });
                }
                catch {
                    // do nothing
                }
            });
        }
        if (isSpa) {
            const { name } = getPerformanceNavigationTiming() || {};
            state.isSpaRouteCheck = name !== document.URL;
            try {
                /**
                 * https://cloud.bytedance.net/docs/slardar/docs/63c8ab7a6773b3023778be76/667bd4697d692e0301b703ac
                 * beforeConfig -> Partial<SlardarConfig>
                 */
                client('on', 'beforeConfig', (userConfig) => {
                    var _a;
                    try {
                        const currentPid = userConfig === null || userConfig === void 0 ? void 0 : userConfig.pid;
                        // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
                        const previousPid = (_a = client('config')) === null || _a === void 0 ? void 0 : _a.pid;
                        if (previousPid && currentPid && currentPid !== previousPid) {
                            state.isSpaRouteCheck = true;
                        }
                    }
                    catch (e) {
                        // do nothing
                    }
                });
            }
            catch (e) {
                console.error('ttap plugin error', e);
            }
        }
        return new Promise((resolve) => {
            client('on', 'init', () => {
                const slardarConfig = generateConfig(config);
                if (slardarConfig) {
                    this._updateConfigSlardarWeb(slardarConfig);
                }
                this._isReady = true;
                this._flushTempSlardarOns();
                this._flushTempSlardarCalls();
                this.setState(state);
                resolve(true);
            });
        });
    }
    updateContext(key, value) {
        const client = this._slardarClientFn();
        if (client) {
            client('context.set', key, value);
            this._hasAdditionalContext = true;
        }
    }
}
export const createSlardarWebClient = (clientFn) => {
    if (!clientFn()) {
        return undefined;
    }
    const client = new Client(clientFn);
    return client;
};
//# sourceMappingURL=slardarWeb.js.map